import axios from 'axios';

export default {
  getProducts() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/products')
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  getCart() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/cart')
        .then(({ data }) => {
          resolve({
            products: data.data,
            meta: data.meta
          });
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  addToCart(product_id, quantity, update = false) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/cart/add', { product_id, quantity, update })
        .then(({ data }) => {
          resolve({
            products: data.data,
            meta: data.meta
          });
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  removeFromCart(product_id) {
    return new Promise((resolve, reject) => {
      axios
        .delete('/api/cart/remove', { data: { product_id } })
        .then(({ data }) => {
          resolve({
            products: data.data,
            meta: data.meta
          });
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },

  emptyCart() {
    return new Promise((resolve, reject) => {
      axios
        .delete('/api/cart/empty')
        .then(() => {
          resolve();
        })
        .catch(error => {
          reject(error.response);
        });
    });
  }
};
